import React, { useState, useEffect } from 'react';
import api from '../../api';
import Modal from '../../components/modals/Modal';
import CodeInput from './CodeInput';
import iconXFill from '../../assets/icone/utils/iconaXFill.svg';

const PhoneVerificationModal = ({ phoneNumber, isOpen, onClose, onVerified }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState('');

  // Funzione per inviare il codice OTP
  const handleSendCode = async () => {
    setError('');
    setMessage('');
    try {
      setIsSending(true);
      const response = await api.post('/auth/send-phone-code', { phoneNumber });
      setMessage('Codice inviato! Controlla il tuo telefono.');
    } catch (err) {
      setError("Errore nell'invio del codice. Riprova.");
    } finally {
      setIsSending(false);
    }
  };

  // useEffect per inviare automaticamente il codice quando la modale si apre
  useEffect(() => {
    if (isOpen) {
      handleSendCode();
    }
  }, [isOpen]);

  // Funzione per verificare il codice inserito dall'utente
  const handleVerifyCode = async () => {
    setError('');
    try {
      const response = await api.post('/auth/verify-phone-code', { phoneNumber, code });
      if (response.data.message.toLowerCase().includes('verificato')) {
        onVerified();
        onClose();
      } else {
        setError('Codice non valido.');
      }
    } catch (err) {
      setError('Errore durante la verifica. Riprova.');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white py-2 mx-4 rounded-md">
        {/* Header con titolo e bottone "x" allineati con justify-between */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-semibold uppercase font-heading">
            Verifica Telefono
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-lg mb-4 text-gray-600"
          >
            <img className="w-4" src={iconXFill} alt="Chiudi" />
          </button>
        </div>
        <p className="mb-8">
          Il codice è stato inviato al numero:
          <br />
          <span className="uppercase text-lg font-semibold">{phoneNumber}</span>
        </p>
        {message && <p className="text-green-600 mb-2">{message}</p>}
        {error && <p className="text-red-600 mb-2">{error}</p>}

        {/* Componente per inserire il codice suddiviso in caselle */}
        <CodeInput length={6} value={code} onChange={setCode} />

        {/* Bottoni impilati verticalmente */}
        <div className="flex flex-col space-y-4 mt-8">
          <button
            type="button"
            onClick={handleSendCode}
            disabled={isSending}
            className="bg-wild-ocean text-white w-full py-3 uppercase font-heading rounded-lg"
          >
            Reinvia Codice
          </button>
          <button
            type="button"
            onClick={handleVerifyCode}
            className="bg-green-adventure text-white w-full py-3 uppercase font-heading rounded-lg"
          >
            Conferma
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PhoneVerificationModal;
